import React from 'react';
import {IconProps} from './types';

export const Association: React.FC<IconProps> = ({ 
    className, 
    width = 17, 
    height = 16, 
    fill = 'black' 
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" fill="none" className={className}>
        <path 
            d="M14.0267 10.6799C14.0882 10.7261 14.1354 10.7888 14.1627 10.8608C14.19 10.9327 14.1963 11.0109 14.181 11.0863C14.1656 11.1617 14.1292 11.2312 14.0759 11.2867C14.0226 11.3422 13.9547 11.3815 13.88 11.3999L11.1667 12.4999L10.08 15.2199C10.0616 15.2946 10.0223 15.3625 9.96677 15.4158C9.91126 15.4691 9.84176 15.5055 9.76637 15.5209C9.69098 15.5362 9.61277 15.5299 9.54084 15.5026C9.46891 15.4753 9.4062 15.4281 9.36 15.3666L0.973333 6.97325C0.690389 6.65821 0.523411 6.25605 0.5 5.83325V2.49992C0.5 2.32311 0.570238 2.15354 0.695262 2.02851C0.820286 1.90349 0.989856 1.83325 1.16667 1.83325H4.5C4.9228 1.85666 5.32496 2.02364 5.64 2.30659L14.0267 10.6799Z" 
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        <path 
            d="M2.5 0.5H6.61333C6.78927 0.499861 6.9635 0.534544 7.12598 0.602052C7.28845 0.669559 7.43596 0.768555 7.56 0.893334L15.0867 8.42667C15.1602 8.50682 15.213 8.60374 15.2404 8.70897C15.2679 8.81421 15.2692 8.92456 15.2442 9.03041C15.2192 9.13625 15.1687 9.23438 15.0971 9.31623C15.0255 9.39809 14.9349 9.46117 14.8333 9.5"
            stroke={fill}
            strokeLinecap="round" 
            strokeLinejoin="round"/>

        <path 
            d="M2.5 4.83325C2.5 5.09847 2.60536 5.35282 2.79289 5.54036C2.98043 5.72789 3.23478 5.83325 3.5 5.83325C3.76522 5.83325 4.01957 5.72789 4.20711 5.54036C4.39464 5.35282 4.5 5.09847 4.5 4.83325C4.5 4.56804 4.39464 4.31368 4.20711 4.12615C4.01957 3.93861 3.76522 3.83325 3.5 3.83325C3.23478 3.83325 2.98043 3.93861 2.79289 4.12615C2.60536 4.31368 2.5 4.56804 2.5 4.83325Z" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"/>
    </svg>
);

export default Association;

